import React, { ReactNode, ReactElement } from 'react';
import { mergeClasses } from '@fluentui/react-components';

import { useEmptyStateSizeContext } from '../contexts/size';
import { useEmptyStateIconStyles } from './empty-state-icon-styles';

interface EmptyStateIconProps {
  className?: string;
  children?: ReactNode;
  icon?: ReactElement;
  fallbackIcon: ReactElement;
}

export const EmptyStateIcon = ({
  className,
  children,
  fallbackIcon,
  icon,
}: EmptyStateIconProps) => {
  const classes = useEmptyStateIconStyles();
  const { size } = useEmptyStateSizeContext();

  return (
    <div className={mergeClasses(className, classes.iconContainer, classes[size])}>
      {children || icon || fallbackIcon}
    </div>
  );
};
